import { render, staticRenderFns } from "./ManageAlertListView.vue?vue&type=template&id=1796f68c"
import script from "./ManageAlertListView.vue?vue&type=script&lang=ts"
export * from "./ManageAlertListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports